import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import PeoplesAndChat from './PeoplesAndChat'
import { useSelector } from "react-redux"
import Rom from './Rom'
import ExerciseProgram from './ExerciseProgram'
import Alert from "../../common/alert"
import SOAPComponent from "./SOAP"
import { isChrome, isFirefox, isSafari, isMobileSafari, isMobileOnly } from "react-device-detect";
import Swal from "sweetalert2"
import ScreenShots from './ScreenShots'
import NewNotes from './NewNotes'




const ChatContiner = props => {

    const [TabsType, setTabsType] = useState("Chat") // Chat // Actions
    const [SelectedTab, setSelectedTab] = useState("Chat") // Chat // Participants  //ROM //EP //SOAP // NewNotes // Screenshots
    const [IsROMEnabled, setIsROMEnabled] = useState(false)
    const [StageHere, setStageHere] = useState(1)

    // { TabsType, SelectedTab },"ForTest")

    const isHost = useSelector(({ meeting }) => meeting.IsHost)
    const IsRomEnabled = useSelector(({ meeting }) => meeting.IsRomEnabled)
    const SOAP = useSelector(({ meeting }) => meeting.SOAP)
    const IsPatientHashMap = useSelector(({ meeting }) => meeting.IsPatientHashMap);
    const PatientsList = useSelector(({ meeting }) => meeting.PatientsList)
    // const PatientsList = ["", ""]
    const ImagesToMap = useSelector(({ meeting }) => meeting.ScreenShotImages)
    const UserData = useSelector(({ auth }) => auth.UserData);
    const SelectedVideoForROM = useSelector(({ meeting }) => meeting.SelectedVideoForROM);

    const width = window.innerWidth < 760 ? true : false;

    // console.log({TabsType})
    // console.log({SelectedTab})
    useEffect(() => {
        props.setStage(StageHere)
        if (StageHere == 0) {
            setStageHere(1)
        }
    }, [StageHere])
    useEffect(() => {
        setTabsType(props.SideBarType)
        setSelectedTab(props.ChatSectionType)
    }, [props.SideBarType, props.ChatSectionType])
    // console.log({SideBarType:props.SideBarType, ChatSectionType:props.ChatSectionType},"IN Chat Container")
    useEffect(() => {
        const MyTime = setInterval(() => {
            CheckingForROM()
        }, 3000);

        return () => {
            clearInterval(MyTime)
        }
    }, [IsPatientHashMap, IsRomEnabled])

    useEffect(() => {
        if (PatientsList.length == 0) {
            setTabsType("Chat")
            setSelectedTab("Chat")
            return
        }
    }, [PatientsList])

    useEffect(() => {
        // console.log(props.ChatBoxOpen)
        // console.log(document.getElementById(SelectedVideoForROM))
        // console.log(SelectedTab)
        if (props.ChatBoxOpen) {
            // console.log(!document.getElementById(SelectedVideoForROM) && SelectedTab == "ROM")
            if (!document.getElementById(SelectedVideoForROM) && SelectedTab == "ROM") {
                setSelectedTab("EP")
            }
        }
    }, [props.ChatBoxOpen, SelectedTab])

    function CheckingForROM() {

        for (const key in IsPatientHashMap) {
            if (IsPatientHashMap[key]) {

                if (IsPatientHashMap[key]?.IsPatient) {
                    return setIsROMEnabled(true)
                }
            }
        }

        return setIsROMEnabled(false)
    }
    return (
        <div style={{ overflow: props.ChatBoxOpen ? "visible" : "hidden", width: props.ChatBoxOpen ? width ? "100%" : (isHost ? "450px" : " 350px") : "0px", height: isMobileOnly ? "100%" : "100vh" }} className="chat-continer">

            {/* <div className="insideBox"> */}

            {/* <div className="ChatBox"> */}
            <div className="Chat-tabs  ">
                {
                    isHost && SOAP ? (
                        <span className="CloseButtonForHostAndMeeting">
                            <span
                                onClick={() => props.CloseChatBox()}
                                className="TheClickyPart">
                                <img

                                    className="closeButton"
                                    src="/images/arrow-right.svg"
                                />
                            </span>
                        </span>
                    ) : (
                        <span
                            style={{ display: props.ChatBoxOpen ? "flex" : "none" }}
                            onClick={() => props.CloseChatBox()}
                            className="closeButton"
                        >
                            <img

                                className="closeButton"
                                src="/images/x.svg"
                            />
                        </span>
                    )
                }
                {
                    TabsType == "Chat" ? (
                        <>
                            <span onClick={async () => {
                                if (StageHere !== 1) {
                                    const res = await Swal.fire(
                                        {
                                            cancelButtonText: "Cancel",
                                            text: "If you change the tab during measurements, all unsaved data will be lost",
                                            title: "Are you sure you want to change tab?",
                                            confirmButtonText: "Confirm",
                                            showCloseButton: true,
                                            showCancelButton: true,
                                        }
                                    )
                                    if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                }
                                setStageHere(1)
                                setSelectedTab("Chat")
                                setTabsType("Chat")
                            }} className={`TabBox ${SelectedTab == "Chat" ? "activeTab" : ""}`}>
                                <h3 style={{ textAlign: "center" }} className="Tab-head ">Chat</h3>
                            </span>
                            <span onClick={async () => {
                                if (StageHere !== 1) {
                                    const res = await Swal.fire(
                                        {
                                            cancelButtonText: "Cancel",
                                            text: "If you change the tab during measurements, all unsaved data will be lost",
                                            title: "Are you sure you want to change tab?",
                                            confirmButtonText: "Confirm",
                                            showCloseButton: true,
                                            showCancelButton: true,
                                        }
                                    )
                                    if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                }
                                setStageHere(1)
                                setSelectedTab("Participants")
                                setTabsType("Chat")

                            }} className={`TabBox ${SelectedTab == "Participants" ? "activeTab" : ""}`}>
                                <h3 style={{ textAlign: "center" }} className="Tab-head ">Participants</h3>
                            </span>

                        </>
                    ) : (
                        <>

                            {
                                isHost ? (
                                    <>
                                        <span onClick={async () => {
                                            if (PatientsList.length != 0) {

                                                if (!document.getElementById(SelectedVideoForROM)) {
                                                    Alert("", "warning", "Please enable rom for a patient before accessing the side menu!")
                                                    return
                                                }
                                                if (StageHere !== 1 && SelectedTab !== "ROM") {
                                                    const res = await Swal.fire(
                                                        {
                                                            cancelButtonText: "Cancel",
                                                            text: "If you change the tab during measurements, all unsaved data will be lost",
                                                            title: "Are you sure you want to change tab?",
                                                            confirmButtonText: "Confirm",
                                                            showCloseButton: true,
                                                            showCancelButton: true,
                                                        }
                                                    )
                                                    if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                                }
                                                setStageHere(1)

                                                setSelectedTab("ROM")

                                            } else {
                                                Alert("", "warning", "Wait for a patient to join before accessing the ROM")
                                            }
                                        }} className={`TabBox ${SelectedTab == "ROM" ? "activeTab" : ""}`}>
                                            <h3 style={{ textAlign: "center" }} className="Tab-head">ROM</h3>
                                        </span>

                                        <span onClick={async () => {
                                            if (PatientsList.length != 0) {
                                                if (StageHere !== 1) {
                                                    const res = await Swal.fire(
                                                        {
                                                            cancelButtonText: "Cancel",
                                                            text: "If you change the tab during measurements, all unsaved data will be lost",
                                                            title: "Are you sure you want to change tab?",
                                                            confirmButtonText: "Confirm",
                                                            showCloseButton: true,
                                                            showCancelButton: true,
                                                        }
                                                    )
                                                    if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                                }
                                                setStageHere(1)

                                                setSelectedTab("EP")
                                            } else {
                                                Alert("", "warning", "Wait for a patient to join before accessing the Exercise Program")
                                            }
                                        }} className={`TabBox EP ${SelectedTab == "EP" ? "activeTab" : ""}`}>
                                            <h3 style={{ textAlign: "center" }} className="Tab-head">Exercise Programs</h3>
                                        </span>

                                        {
                                            // true ? (
                                                SOAP && !UserData?.permissions?.includes(25) ? (
                                                <>
                                                    <span onClick={async () => {
                                                        if (PatientsList.length != 0) {
                                                            if (StageHere !== 1) {
                                                                const res = await Swal.fire(
                                                                    {
                                                                        cancelButtonText: "Cancel",
                                                                        text: "If you change the tab during measurements, all unsaved data will be lost",
                                                                        title: "Are you sure you want to change tab?",
                                                                        confirmButtonText: "Confirm",
                                                                        showCloseButton: true,
                                                                        showCancelButton: true,
                                                                    }
                                                                )
                                                                if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                                            }
                                                            setStageHere(1)

                                                            setSelectedTab("SOAP")
                                                        } else {
                                                            Alert("", "warning", "Wait for a patient to join before accessing the SOAP")
                                                        }
                                                    }} className={`TabBox  ${SelectedTab == "SOAP" ? "activeTab" : ""}`}>
                                                        <h3 style={{ textAlign: "center" }} className="Tab-head">SOAP</h3>
                                                    </span>



                                                </>
                                            ) : null
                                        }

                                        {
                                            SOAP ? (
                                                <span onClick={async () => {
                                                    if (PatientsList.length != 0) {
                                                        if (StageHere !== 1) {
                                                            const res = await Swal.fire(
                                                                {
                                                                    cancelButtonText: "Cancel",
                                                                    text: "If you change the tab during measurements, all unsaved data will be lost",
                                                                    title: "Are you sure you want to change tab?",
                                                                    confirmButtonText: "Confirm",
                                                                    showCloseButton: true,
                                                                    showCancelButton: true,
                                                                }
                                                            )
                                                            if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                                        }
                                                        setStageHere(1)

                                                        setSelectedTab("NewNotes")
                                                    } else {
                                                        Alert("", "warning", "Wait for a patient to join before accessing the Exercise Program")
                                                    }
                                                }} className={`TabBox  ${SelectedTab == "NewNotes" ? "activeTab" : ""}`}>
                                                    <h3 style={{ textAlign: "center" }} className="Tab-head">Notes</h3>
                                                </span>
                                            ) : null
                                        }


                                        {
                                            SOAP ? (

                                                <span onClick={async () => {
                                                    if (PatientsList.length != 0) {
                                                        if (StageHere !== 1) {
                                                            const res = await Swal.fire(
                                                                {
                                                                    cancelButtonText: "Cancel",
                                                                    text: "If you change the tab during measurements, all unsaved data will be lost",
                                                                    title: "Are you sure you want to change tab?",
                                                                    confirmButtonText: "Confirm",
                                                                    showCloseButton: true,
                                                                    showCancelButton: true,
                                                                }
                                                            )
                                                            if (!res.value || res.dismiss == "cancel" || res.dismiss == "close") return

                                                        }
                                                        setStageHere(1)

                                                        if (ImagesToMap.length == 0) {
                                                            return Alert("", "warning", "Please take a screenshot before accessing the screenshots tab!")

                                                        }

                                                        setSelectedTab("Screenshots")
                                                    } else {
                                                        Alert("", "warning", "Wait for a patient to join before accessing the Screenshots")
                                                    }
                                                }} className={`TabBox SS ${SelectedTab == "Screenshots" ? "activeTab" : ""}`}>
                                                    <h3 style={{ textAlign: "center" }} className="Tab-head">Screenshots</h3>
                                                </span>


                                            ) : null
                                        }


                                    </>
                                ) : null
                            }

                        </>
                    )
                }


            </div>

            {
                SelectedTab == "Chat" || SelectedTab == "Participants" ? <PeoplesAndChat ChatTabType={SelectedTab} /> : null
            }
            {
                SelectedTab == "ROM" ? <Rom setStageHere={(e) => {
                    setStageHere(e)
                }} /> : null
            }
            {
                SelectedTab == "EP" ? <ExerciseProgram Search={props.Search} /> : null
            }
            {
                SelectedTab == "SOAP" ? <SOAPComponent /> : null
            }
            {
                SelectedTab == "NewNotes" ? <NewNotes /> : null
            }
            {
                SelectedTab == "Screenshots" ? <ScreenShots setStageHere={(e) => {
                    setStageHere(e)
                }} /> : null
            }
            {/* </div> */}
            {/* </div> */}
        </div >
    )
}

ChatContiner.propTypes = {
    ChatBoxOpen: PropTypes.bool.isRequired,
    CloseChatBox: PropTypes.func.isRequired,
    Search: PropTypes.func.isRequired,
}

export default ChatContiner
